import { ActionContext } from 'vuex'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IDebugState } from './state'
import { DebugItem } from '@/models/ui/DebugItem';

export class DebugAction {
  public [types.DEBUG_ADD_ITEMS](context: ActionContext<IDebugState, IRootState>, item: DebugItem) {
    return new Promise((resolve, reject) => {
      context.commit(types.DEBUG_ADD_ITEMS,item)
      resolve(item)
    })
  }

  public [types.DEBUG_AUTOSAVE](context: ActionContext<IDebugState, IRootState>) {
    return new Promise<void>((resolve, reject) => {      
      resolve()
    })
  }
  
  public [types.DEBUG_TOGGLE_STATE](context: ActionContext<IDebugState, IRootState>) {
    return new Promise<void>((resolve, reject) => {          
      context.commit(types.DEBUG_TOGGLE_STATE)  
      resolve()
    })
  }

  public [types.DEBUG_UPDATE_FILTER](context: ActionContext<IDebugState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.DEBUG_UPDATE_FILTER,newProperties)
      resolve(context.state.debugFilter)
    })
  }
  
}

export default util.classToObject(DebugAction)
